function getDesempenoState(state) {
  return {
    posting: state.desempeno.posting,
    loadingPostingInfo: state.desempeno.loadingPosting,
    postingError: state.desempeno.postingError,
    impressions: state.desempeno.impressions,
    loadingImpressions: state.desempeno.loadingImpressions,
    impressionsError: state.desempeno.impressionsError,
    visits: state.desempeno.visits,
    loadingVisits: state.desempeno.loadingVisits,
    visitsError: state.desempeno.visitsError,
    leads: state.desempeno.leads,
    leadsUnread: state.desempeno.leadsUnread,
    loadingLeads: state.desempeno.loadingLeads,
    leadsError: state.desempeno.leadsError,
    postingQuality: state.desempeno.postingQuality,
    loadingPostingQuality: state.desempeno.loadingPostingQuality,
    postingQualityError: state.desempeno.postingQualityError,
    userIsAuthorized: state.desempeno.userIsAuthorized,
    loadingAuthorization: state.desempeno.loadingAuthorization,
    leadsStats: state.desempeno.leadsStats,
    postingLogs: state.desempeno.postingLogs,
    postingTips: state.desempeno.postingTips,
    loadingTips: state.desempeno.loadingTips,
    postingReports: state.desempeno.postingReports,
    hasGlobalCredits: state.desempeno.hasGlobalCredits,
    credits: state.desempeno.credits,
    loadingCredits: state.desempeno.loadingCredits,
    publishPostingError: state.desempeno.publishPostingError,
    publishPostingSuccess: state.desempeno.publishPostingSuccess,
    saveTagError: state.desempeno.saveTagError,
    saveTagSuccess: state.desempeno.saveTagSuccess,
    isDuplicate: state.desempeno.isDuplicate,
    isPenalized: state.desempeno.isPenalized,
    isRentedOrSold: state.desempeno.isRentedOrSold,
    hasDesempenoData: state.desempeno.hasDesempenoData,
    postingInfoToShare: state.desempeno.postingInfoToShare,
    hashToShareInfoPerformance: state.desempeno.hash,
    hasInfoShared: state.desempeno.hasInfoShared,
    infoSharedError: state.desempeno.infoSharedError,
    loadingInfoShared: state.desempeno.loadingInfoShared,
    finishReason: state.desempeno.finishReason,
    loadingFinishReason: state.desempeno.loadingFinishReason,
    loadingSuspendPosting: state.desempeno.loadingSuspendPosting,
    fetchedSuspendPosting: state.desempeno.fetchedSuspendPosting,
    suspendSuccessful: state.desempeno.suspendSuccessful,
    recievedSuccessfulResponse: state.desempeno.recievedSuccessfulResponse,
    suspendError: state.desempeno.suspendError,
    appliesToI24Full: state.desempeno.appliesToI24Full,
    postingUnreadLeads: state.desempeno.postingUnreadLeads,
    showUnreadLeadsModal: state.desempeno.showUnreadLeadsModal,
    postingIds: state.desempeno.postingIds,
    loadingSendUnreadLeads: state.desempeno.loadingSendUnreadLeads,
    sendUnreadLeadsMsgSuccess: state.desempeno.sendUnreadLeadsMsgSuccess,
    sendUnreadLeadsMsgError: state.desempeno.sendUnreadLeadsMsgError,
    hasUnreadLeadsLoading: state.desempeno.hasUnreadLeadsLoading,
    hasUnreadLeadsSuccess: state.desempeno.hasUnreadLeadsSuccess,
    hasUnreadLeadsError: state.desempeno.hasUnreadLeadsError,
    hasUnreadLeads: state.desempeno.hasUnreadLeads,
    postingFull: state.desempeno.postingFull,
    postingFullLoading: state.desempeno.postingFullLoading,
    postingFullError: state.desempeno.postingFullError,
    postingFullSuccess: state.desempeno.postingFullSuccess
  };
}

export { getDesempenoState };
